module.exports = __webpack_public_path__ + "static/media/SI.cab53f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SI.svg
// module id = 2258
// module chunks = 7